import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }

        .vt-home {
          min-height: 100vh;
          background:
            radial-gradient(circle at 88% 8%, rgba(191,139,51,.15), transparent 28%),
            radial-gradient(circle at 8% 88%, rgba(14,78,67,.38), transparent 35%),
            #061d1b;
          color: #f5f1e8;
          font-family: Inter, Arial, sans-serif;
          overflow-x: hidden;
        }

        @media (min-width: 993px) {
          .vt-home {
            position: relative;
            left: calc(-1 * var(--sbw));
            width: calc(100% + var(--sbw));
          }
        }

        .vt-shell {
          width: min(1180px, calc(100% - 40px));
          margin: 0 auto;
        }

        .vt-nav {
          height: 84px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(222,177,90,.18);
        }

        .vt-brand {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .vt-brand-main {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 25px;
          letter-spacing: .3px;
          color: #f8f4eb;
        }

        .vt-brand-sub {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 2.4px;
          color: #c79a46;
        }

        .vt-enter {
          border: 1px solid rgba(215,167,75,.7);
          background: rgba(215,167,75,.08);
          color: #f3c56f;
          font-weight: 700;
          padding: 11px 24px;
          border-radius: 999px;
          cursor: pointer;
          transition: .2s ease;
        }

        .vt-enter:hover {
          transform: translateY(-1px);
          background: #c8943e;
          color: #071d1a;
        }

        .vt-hero {
          min-height: 650px;
          display: grid;
          grid-template-columns: 1.08fr .92fr;
          gap: 58px;
          align-items: center;
          padding: 70px 0 82px;
        }

        .vt-kicker {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          color: #d3a34d;
          text-transform: uppercase;
          letter-spacing: 2.2px;
          font-size: 12px;
          font-weight: 800;
          margin-bottom: 22px;
        }

        .vt-kicker::before {
          content: '';
          width: 34px;
          height: 1px;
          background: #d3a34d;
        }

        .vt-title {
          margin: 0;
          max-width: 720px;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: clamp(52px, 6vw, 82px);
          line-height: .98;
          font-weight: 400;
          letter-spacing: -2.8px;
        }

        .vt-title-gold {
          color: #c99845;
        }

        .vt-subtitle {
          margin: 26px 0 0;
          max-width: 690px;
          font-size: clamp(20px, 2vw, 27px);
          line-height: 1.35;
          color: #e9bd6b;
          font-weight: 600;
        }

        .vt-copy {
          margin: 20px 0 0;
          max-width: 660px;
          color: #c8d0cc;
          font-size: 16px;
          line-height: 1.72;
        }

        .vt-hero-actions {
          display: flex;
          gap: 14px;
          margin-top: 32px;
          flex-wrap: wrap;
        }

        .vt-primary {
          border: 0;
          background: #c8973f;
          color: #08201d;
          padding: 14px 25px;
          border-radius: 8px;
          font-weight: 800;
          cursor: pointer;
          transition: .2s ease;
        }

        .vt-primary:hover {
          transform: translateY(-1px);
          background: #dfb45f;
        }

        .vt-secondary {
          display: inline-flex;
          align-items: center;
          padding: 14px 0;
          color: #d7ddd8;
          font-size: 14px;
          font-weight: 700;
        }

        .vt-visual {
          position: relative;
          min-height: 520px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .vt-orbit {
          position: absolute;
          width: 500px;
          height: 500px;
          border-radius: 50%;
          border: 1px solid rgba(210,161,70,.35);
        }

        .vt-orbit::before,
        .vt-orbit::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(210,161,70,.15);
        }

        .vt-orbit::before { inset: 44px; }
        .vt-orbit::after { inset: 93px; }

        .vt-panel {
          position: relative;
          z-index: 2;
          width: min(450px, 92%);
          border: 1px solid rgba(215,170,82,.38);
          border-radius: 24px;
          padding: 28px;
          background:
            linear-gradient(160deg, rgba(13,55,49,.96), rgba(4,25,23,.98));
          box-shadow: 0 28px 80px rgba(0,0,0,.28);
        }

        .vt-panel-label {
          color: #d1a14b;
          text-transform: uppercase;
          letter-spacing: 1.8px;
          font-size: 10px;
          font-weight: 800;
        }

        .vt-panel-title {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 29px;
          margin: 10px 0 4px;
          color: #fff8eb;
        }

        .vt-panel-note {
          color: #9fb0aa;
          font-size: 13px;
          margin-bottom: 28px;
        }

        .vt-bars {
          display: grid;
          gap: 14px;
        }

        .vt-bar-row {
          display: grid;
          grid-template-columns: 118px 1fr 34px;
          gap: 12px;
          align-items: center;
          font-size: 12px;
          color: #d5ddd9;
        }

        .vt-track {
          height: 7px;
          border-radius: 999px;
          background: rgba(255,255,255,.08);
          overflow: hidden;
        }

        .vt-fill {
          height: 100%;
          border-radius: 999px;
          background: linear-gradient(90deg, #8f6a2d, #dfb75f);
        }

        .vt-index {
          margin-top: 28px;
          padding: 18px;
          border-radius: 14px;
          background: rgba(0,0,0,.16);
          border: 1px solid rgba(255,255,255,.05);
          display: flex;
          align-items: end;
          justify-content: space-between;
        }

        .vt-index-small {
          font-size: 11px;
          color: #9aacA6;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .vt-index-number {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 44px;
          color: #e0b35d;
          line-height: 1;
        }

        .vt-section {
          padding: 92px 0;
        }

        .vt-light {
          background: #f4efe6;
          color: #102b28;
        }

        .vt-section-head {
          max-width: 800px;
          margin-bottom: 50px;
        }

        .vt-eyebrow {
          color: #b9832f;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 11px;
          font-weight: 800;
          margin-bottom: 14px;
        }

        .vt-h2 {
          margin: 0;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: clamp(38px, 4vw, 58px);
          line-height: 1.07;
          font-weight: 400;
          letter-spacing: -1.3px;
        }

        .vt-section-text {
          margin-top: 18px;
          max-width: 760px;
          font-size: 17px;
          line-height: 1.7;
          color: #536560;
        }

        .vt-dark-text {
          color: #aebbb6;
        }

        .vt-process {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 14px;
        }

        .vt-step {
          padding: 26px 20px;
          border-top: 1px solid rgba(23,67,60,.18);
        }

        .vt-step-number {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 35px;
          color: #b27e2b;
        }

        .vt-step-title {
          font-weight: 800;
          margin: 12px 0 9px;
          color: #163c36;
        }

        .vt-step-copy {
          color: #5a6965;
          font-size: 14px;
          line-height: 1.55;
        }

        .vt-feature-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 18px;
          margin-top: 45px;
        }

        .vt-feature {
          padding: 26px;
          min-height: 210px;
          border: 1px solid rgba(211,162,72,.2);
          border-radius: 15px;
          background: rgba(255,255,255,.025);
        }

        .vt-feature-no {
          color: #cf9c45;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 29px;
          margin-bottom: 22px;
        }

        .vt-feature h3 {
          margin: 0 0 10px;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 23px;
          color: #f4efe5;
          font-weight: 400;
        }

        .vt-feature p {
          margin: 0;
          color: #aab8b3;
          line-height: 1.6;
          font-size: 14px;
        }

        .vt-training {
          display: grid;
          grid-template-columns: .9fr 1.1fr;
          gap: 70px;
          align-items: start;
        }

        .vt-training-list {
          display: grid;
          gap: 18px;
        }

        .vt-training-item {
          display: grid;
          grid-template-columns: 58px 1fr;
          gap: 18px;
          padding: 20px 0;
          border-bottom: 1px solid rgba(18,60,53,.14);
        }

        .vt-training-num {
          font-family: Georgia, 'Times New Roman', serif;
          color: #b17a28;
          font-size: 28px;
        }

        .vt-training-item h3 {
          margin: 0 0 7px;
          color: #153b35;
          font-size: 17px;
        }

        .vt-training-item p {
          margin: 0;
          color: #5c6a66;
          font-size: 14px;
          line-height: 1.55;
        }

        .vt-quote {
          margin-top: 30px;
          padding: 22px 24px;
          border-left: 3px solid #bb8734;
          background: rgba(188,135,52,.08);
          color: #183c37;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 22px;
          line-height: 1.35;
        }

        .vt-final {
          padding: 90px 0 100px;
          text-align: center;
          position: relative;
        }

        .vt-final::before {
          content: '';
          position: absolute;
          top: 0;
          left: 10%;
          right: 10%;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(210,159,65,.4), transparent);
        }

        .vt-final h2 {
          margin: 0 auto;
          max-width: 860px;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: clamp(40px, 5vw, 64px);
          line-height: 1.08;
          font-weight: 400;
        }

        .vt-final p {
          margin: 18px auto 30px;
          max-width: 680px;
          color: #aab7b2;
          font-size: 16px;
          line-height: 1.65;
        }

        .vt-footer {
          border-top: 1px solid rgba(215,170,82,.16);
          background: #04332f;
          color: #eef2ef;
          padding: 58px 0 26px;
        }

        .vt-footer-grid {
          display: grid;
          grid-template-columns: 1.2fr .75fr 1fr;
          gap: 70px;
          padding-bottom: 48px;
        }

        .vt-footer-title {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 28px;
          color: #fff8eb;
          margin-bottom: 9px;
        }

        .vt-footer-tag {
          color: #c8943e;
          text-transform: uppercase;
          letter-spacing: 1.8px;
          font-size: 10px;
          font-weight: 800;
          margin-bottom: 24px;
        }

        .vt-footer-copy {
          max-width: 500px;
          color: #d2ddd8;
          font-size: 14px;
          line-height: 1.75;
        }

        .vt-footer-heading {
          color: #d3a34d;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 11px;
          font-weight: 800;
          margin-bottom: 20px;
        }

        .vt-footer-links {
          display: grid;
          gap: 14px;
        }

        .vt-footer-link {
          background: none;
          border: 0;
          padding: 0;
          color: #eef2ef;
          text-align: left;
          font: inherit;
          font-size: 14px;
          cursor: pointer;
          width: auto;
        }

        .vt-footer-link:hover {
          color: #d3a34d;
        }

        .vt-footer-contact {
          display: grid;
          gap: 13px;
          color: #d2ddd8;
          font-size: 14px;
          line-height: 1.55;
        }

        .vt-footer-bottom {
          border-top: 1px solid rgba(255,255,255,.11);
          padding-top: 25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 25px;
          color: #aabbb5;
          font-size: 12px;
        }

        @media (max-width: 900px) {
          .vt-hero {
            grid-template-columns: 1fr;
            gap: 25px;
            padding-top: 45px;
          }

          .vt-visual { min-height: 430px; }
          .vt-orbit { width: 410px; height: 410px; }

          .vt-process {
            grid-template-columns: 1fr 1fr;
          }

          .vt-feature-grid {
            grid-template-columns: 1fr 1fr;
          }

          .vt-training {
            grid-template-columns: 1fr;
            gap: 45px;
          }
        }

        @media (max-width: 620px) {
          .vt-shell {
            width: min(100% - 28px, 1180px);
          }

          .vt-nav { height: 72px; }
          .vt-brand-main { font-size: 21px; }
          .vt-brand-sub { font-size: 8px; }
          .vt-enter { padding: 9px 16px; }

          .vt-title {
            font-size: clamp(30px, 8.6vw, 38px);
            line-height: 1.02;
            letter-spacing: -1.2px;
            overflow-wrap: anywhere;
          }

          .vt-subtitle {
            font-size: 19px;
            line-height: 1.4;
            overflow-wrap: anywhere;
          }

          .vt-h2 {
            font-size: clamp(32px, 9vw, 40px);
            line-height: 1.1;
            overflow-wrap: anywhere;
          }

          .vt-final h2 {
            font-size: clamp(34px, 9.5vw, 42px);
            overflow-wrap: anywhere;
          }

          .vt-copy,
          .vt-section-text {
            max-width: 100%;
            overflow-wrap: anywhere;
          }

          .vt-visual { min-height: 390px; }
          .vt-orbit { width: 330px; height: 330px; }
          .vt-panel { padding: 21px; }
          .vt-bar-row { grid-template-columns: 90px 1fr 28px; }

          .vt-section { padding: 68px 0; }

          .vt-process,
          .vt-feature-grid {
            grid-template-columns: 1fr;
          }

          .vt-step { padding-left: 0; padding-right: 0; }
          .vt-feature { min-height: 0; }

          .vt-final {
            padding: 70px 0 80px;
          }

          .vt-footer-grid {
            grid-template-columns: 1fr;
            gap: 38px;
          }

          .vt-footer-bottom {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

      <main className="vt-home">
        <div className="vt-shell">
          <header className="vt-nav">
            <div className="vt-brand">
              <div className="vt-brand-main">Vendas Training</div>
              <div className="vt-brand-sub">Avaliação • Direção • Desenvolvimento</div>
            </div>

            <button
              className="vt-enter"
              type="button"
              onClick={() => navigate('/login')}
            >
              Entrar
            </button>
          </header>

          <section className="vt-hero">
            <div>
              <div className="vt-kicker">Performance comercial com critério</div>

              <h1 className="vt-title">
                Desenvolvimento em vendas começa com
                <span className="vt-title-gold"> diagnóstico preciso.</span>
              </h1>

              <p className="vt-subtitle">
                Avaliar com precisão. Direcionar por perfil e contexto.
                Desenvolver para alta performance.
              </p>

              <p className="vt-copy">
                O Vendas Training combina avaliação de competências, diagnóstico
                comercial e desenvolvimento direcionado para transformar treinamento
                em intervenção prática, aderente ao papel de venda e às necessidades
                reais de cada profissional e equipe.
              </p>

              <div className="vt-hero-actions">
                <button
                  type="button"
                  className="vt-primary"
                  onClick={() => navigate('/login')}
                >
                  Entrar na plataforma
                </button>

                <span className="vt-secondary">
                  ICV — Inventário de Competências para Vendas
                </span>
              </div>
            </div>

            <div className="vt-visual" aria-hidden="true">
              <div className="vt-orbit" />

              <div className="vt-panel">
                <div className="vt-panel-label">ICV • Perfil de Competências</div>
                <div className="vt-panel-title">Leitura comercial individual</div>
                <div className="vt-panel-note">
                  Visual demonstrativo do diagnóstico de competências
                </div>

                <div className="vt-bars">
                  {[
                    ['Compreensão', 78],
                    ['Adaptabilidade', 66],
                    ['Autocontrole', 72],
                    ['Segurança', 84],
                    ['Atividade', 61],
                    ['Sociabilidade', 74]
                  ].map(([label, value]) => (
                    <div className="vt-bar-row" key={label}>
                      <span>{label}</span>
                      <div className="vt-track">
                        <div className="vt-fill" style={{ width: `${value}%` }} />
                      </div>
                      <span>{value}</span>
                    </div>
                  ))}
                </div>

                <div className="vt-index">
                  <div>
                    <div className="vt-index-small">Índice geral</div>
                    <div style={{ color: '#c9d4cf', fontSize: 13, marginTop: 4 }}>
                      Referência consolidada
                    </div>
                  </div>
                  <div className="vt-index-number">7,6</div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section className="vt-section vt-light">
          <div className="vt-shell">
            <div className="vt-section-head">
              <div className="vt-eyebrow">Método</div>
              <h2 className="vt-h2">
                Antes de treinar, é preciso saber o que desenvolver.
              </h2>
              <p className="vt-section-text">
                Pessoas diferentes não precisam do mesmo treinamento. O processo
                começa pela leitura das competências e do contexto comercial,
                avança para o direcionamento das necessidades e se converte em
                desenvolvimento aplicado à realidade de vendas.
              </p>
            </div>

            <div className="vt-process">
              {[
                ['01', 'Avaliar', 'Identificar competências e padrões relevantes para a atuação comercial.'],
                ['02', 'Diagnosticar', 'Interpretar forças, lacunas e necessidades reais de desenvolvimento.'],
                ['03', 'Direcionar', 'Relacionar o diagnóstico ao papel comercial e ao contexto do negócio.'],
                ['04', 'Desenvolver', 'Treinar habilidades específicas com prática, feedback e aplicação.'],
                ['05', 'Acompanhar', 'Observar evolução, ajustar a rota e sustentar o desenvolvimento.']
              ].map(([n, title, text]) => (
                <div className="vt-step" key={n}>
                  <div className="vt-step-number">{n}</div>
                  <div className="vt-step-title">{title}</div>
                  <div className="vt-step-copy">{text}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="vt-section">
          <div className="vt-shell">
            <div className="vt-section-head">
              <div className="vt-eyebrow">ICV</div>
              <h2 className="vt-h2">
                Inventário de Competências para Vendas
              </h2>
              <p className="vt-section-text vt-dark-text">
                O ICV é a camada diagnóstica do Vendas Training. Ele estrutura uma
                leitura das competências comportamentais relevantes para a
                performance comercial e transforma a avaliação em informação útil
                para decisões de desenvolvimento.
              </p>
            </div>

            <div className="vt-feature-grid">
              {[
                ['01', 'Mapa de competências', 'Leitura estruturada das competências comportamentais relacionadas à atuação em vendas.'],
                ['02', 'Forças e pontos críticos', 'Evidencia padrões que favorecem a performance e aspectos que merecem desenvolvimento.'],
                ['03', 'Decisões mais assertivas', 'Apoia desenvolvimento, alocação, acompanhamento e gestão de equipes comerciais.'],
                ['04', 'Leitura individual e de equipe', 'Permite compreender necessidades específicas sem reduzir profissionais a um perfil genérico.'],
                ['05', 'Direção para o treinamento', 'Conecta diagnóstico e contexto para orientar temas, prioridades e intensidade do desenvolvimento.'],
                ['06', 'Evolução acompanhada', 'Cria base para observar mudanças, rever necessidades e sustentar a evolução comercial.']
              ].map(([n, title, text]) => (
                <article className="vt-feature" key={n}>
                  <div className="vt-feature-no">{n}</div>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="vt-section vt-light">
          <div className="vt-shell vt-training">
            <div>
              <div className="vt-eyebrow">Vendas Training</div>
              <h2 className="vt-h2">
                Treinamento ajustado ao estilo real de venda.
              </h2>

              <p className="vt-section-text">
                O treinamento é construído a partir do diagnóstico, do modelo de
                negócio, das exigências do papel comercial e das necessidades
                observadas em cada profissional ou equipe.
              </p>

              <div className="vt-quote">
                Menos treinamento genérico. Mais desenvolvimento comercial com
                critério, aderência e aplicação.
              </div>
            </div>

            <div className="vt-training-list">
              {[
                ['01', 'Diagnóstico inicial', 'ICV, leitura do perfil comercial e identificação das necessidades prioritárias.'],
                ['02', 'Contexto e papel de venda', 'O desenvolvimento considera o que a operação exige de Hunters, Farmers, Closers e outras configurações comerciais.'],
                ['03', 'Treinamento direcionado', 'Prospecção, relacionamento, negociação, fechamento, rotina comercial e outras habilidades são trabalhadas conforme a necessidade real.'],
                ['04', 'Aplicação e acompanhamento', 'Prática orientada, feedback, ajustes de rota e acompanhamento da evolução ao longo do processo.']
              ].map(([n, title, text]) => (
                <div className="vt-training-item" key={n}>
                  <div className="vt-training-num">{n}</div>
                  <div>
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="vt-final">
          <div className="vt-shell">
            <div className="vt-eyebrow">Vendas Training</div>
            <h2>
              Clareza para avaliar.
              <br />
              Direção para desenvolver.
            </h2>
            <p>
              Uma abordagem de desenvolvimento comercial que conecta avaliação,
              contexto, treinamento e acompanhamento em um mesmo processo.
            </p>

            <button
              type="button"
              className="vt-primary"
              onClick={() => navigate('/login')}
            >
              Entrar na plataforma
            </button>
          </div>
        </section>

        <footer className="vt-footer">
          <div className="vt-shell">
            <div className="vt-footer-grid">
              <div>
                <div className="vt-footer-title">Vendas Training</div>
                <div className="vt-footer-tag">
                  Avaliação • Direção • Desenvolvimento
                </div>
                <div className="vt-footer-copy">
                  Desenvolvimento comercial orientado por diagnóstico, contexto e
                  necessidades reais de vendedores, equipes e lideranças comerciais.
                  O ICV estrutura a avaliação que dá base ao direcionamento do
                  treinamento.
                </div>
              </div>

              <div>
                <div className="vt-footer-heading">Acesso</div>
                <div className="vt-footer-links">
                  <button
                    className="vt-footer-link"
                    type="button"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Página inicial
                  </button>
                  <button
                    className="vt-footer-link"
                    type="button"
                    onClick={() => navigate('/login')}
                  >
                    Entrar na plataforma
                  </button>
                </div>
              </div>

              <div>
                <div className="vt-footer-heading">Contato</div>
                <div className="vt-footer-contact">
                  <span>Fractal Tecnologia em Gestão de Pessoas</span>
                  <span><strong>E-mail:</strong> contato@fractalrh.com.br</span>
                  <span><strong>Site:</strong> www.fractalrh.com.br</span>
                </div>
              </div>
            </div>

            <div className="vt-footer-bottom">
              <span>© 2026 Fractal Tecnologia em Gestão de Pessoas. Todos os direitos reservados.</span>
              <span>Vendas Training • Desenvolvimento comercial orientado por diagnóstico.</span>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
}



